// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dotted-line {\n  border-bottom: 2px dotted black; }\n", "",{"version":3,"sources":["webpack://src/components/Input/style.scss"],"names":[],"mappings":"AAAA;EACE,+BAA+B,EAAA","sourcesContent":[".dotted-line {\n  border-bottom: 2px dotted black;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
